import { Injectable } from '@angular/core';
import { CoolHttp } from '@angular-cool/http';
import { CampaignId, CampaignSessionFullDTO, CampaignSessionId, CampaignSessionMinimumDTO } from '../../../../../common/dto/campaigns.dto';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import { MINUTE_IN_MILLISECONDS } from '../../../../../common/utils/date.utils';
import { Observable, Subject } from 'rxjs';
import { CacheState, CacheStateUpdater } from '@coool/cachestate';
import { filter } from 'rxjs/operators';
import { filterDefined } from '../utils/observable.utils';

const campaignSessionsCacheUpdater = new Subject<string | void>();

@Injectable()
export class CampaignSessionsService {
  constructor(private _http: CoolHttp) {}

  @CacheState({
    maxAgeMS: 5 * MINUTE_IN_MILLISECONDS,
    cacheKey: {
      generator: args => `campaign-sessions_${args[0]}`,
    },
    updatedObservable: campaignSessionsCacheUpdater.pipe(filterDefined()),
  })
  public getCampaignSessionsCACHED(campaignId: CampaignId): Observable<CampaignSessionMinimumDTO[]> {
    return this._http.getObservable(
      ServerUrls.Campaigns.children.Sessions.children.Get.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Sessions.params.campaignId]: campaignId,
      }),
    );
  }

  @CacheStateUpdater({
    cacheKeyGenerator: args => `campaign-sessions_${args[0]}`,
    updatedNotifier: campaignSessionsCacheUpdater,
  })
  public async createCampaignSessionAsync(campaignId: CampaignId): Promise<CampaignSessionMinimumDTO> {
    return await this._http.postAsync(
      ServerUrls.Campaigns.children.Sessions.children.Create.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Sessions.params.campaignId]: campaignId,
      }),
    );
  }

  @CacheState({
    maxAgeMS: 5 * MINUTE_IN_MILLISECONDS,
    cacheKey: {
      generator: args => `campaign-session_${args[1]}`,
    },
  })
  public getCampaignSessionByIdCACHED(campaignId: CampaignId, campaignSessionId: CampaignSessionId): Observable<CampaignSessionFullDTO> {
    return this._http.getObservable(
      ServerUrls.Campaigns.children.Sessions.children.GetById.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Sessions.params.campaignId]: campaignId,
        [ServerUrls.Campaigns.children.Sessions.children.GetById.params.campaignSessionId]: campaignSessionId,
      }),
    );
  }
}
